import React from 'react'
import { EmptyIcon } from '../../../../assets/icons/NotificationsEmptyIcon'
import { useLocation } from 'react-router-dom';
import { EmptyTransIcon } from '../../../../assets/icons/ResentTransactionEmptyIcon';



const Empty = () => {

  let text = `You do not have any transactions yet. Create an expense or invoice to see data `;


  return (
    <div>
      <div className="h-[100px] w-[200px] mt-[3.2em] ml-[4.8em] md:ml-[15em] 540:ml-[7em] bigmd:ml-[17.5em] lg:ml-[9em] items-center justify-center  xl:w-full xl:ml-[1em]  flex flex-col ">
        <EmptyTransIcon />
        <div className="flex items-center justify-center ">
          <p className="text-[12px] md:text-[14px] xl:font-medium text-black mt-[-1em]" > You do not have any transactions yet. Create  
         <span className='xl:flex xl:justify-center 'style={{ whiteSpace: 'nowrap' }}> an expense or invoice to see data </span>  </p>
        </div>
      </div>
    </div>
  )
}

export default Empty